Apt.fn.make('lazy', {
	/**
	 * Initialize module
	 *
	 * @param {$} target
	 * @param {Object} [options]
	 * @returns {Object}
	 */
	init(target, options) {
		const scope = this;
		const priv = scope.$private;

		priv.target = $(target);
		priv.uid = LS.util.uid();

		priv.conf = Object.assign({
			margin: 380
		}, options);

		priv.bind();

		return scope;
	},

	/**
	 * Destroy module
	 *
	 * @private
	 */
	_destruct() {
		const priv = this.$private;

		$.events.reset(priv.uid);
		$.scroll.reset(priv.uid);

		priv.target = [];
	}
}, {
	/**
	 * Bind lazy load events
	 */
	bind() {
		const scope = this;
		const conf = scope.conf;

		scope.target = scope.target.filter('img')
			.attr('data-ignore', true);

		const fn = e => {
			const img = e.target;

			img.decoding = 'async';

			img.addEventListener('load', () => {
				requestAnimationFrame(() => {
					img.classList.add('-is-loaded');
				});
			}, {
				once: true
			});

			img.src = img.dataset.src;
		};

		requestAnimationFrame(() => {
			LS.util.scrolled(scope.target, scope.uid, fn, conf);
		});
	}
});